import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { trigger, transition, query, animate, style } from '@angular/animations';

@Component({
  selector: 'tonteppich-root',
  templateUrl: './tonteppich.component.html',
  styleUrls: ['./tonteppich.component.scss'],
  animations: [
    trigger('routeAnimations', [
      transition('home => references', [
        query(':enter', style({ position: 'absolute' })),
        query('.left', animate(500, style({ zIndex: 12 }))),
        query('.left-2', animate(500, style({ zIndex: 14 }))),
        query(':enter', [
          animate('500ms linear', style({ zIndex: 16 }))
        ])
      ]),
      transition('home => contact', [
        query(':enter', style({ position: 'absolute' })),
        query('.left', animate(500, style({ zIndex: 12 }))),
        query('.left-2', animate(500, style({ zIndex: 14 }))),
        query(':enter', [
          animate('500ms linear', style({ zIndex: 16 }))
        ])
      ]),
      transition('home => equipment', [
        query(':enter', style({ position: 'absolute' })),
        query('.right', animate(500, style({ zIndex: 12 }))),
        query('.right-2', animate(500, style({ zIndex: 14 }))),
        query(':enter', [
          animate('500ms linear', style({ zIndex: 16 }))
        ])
      ])
    ])
  ]
})
export class TonteppichComponent {
  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
}
